import React from 'react'
import axios from 'axios'

import SimpleTable from '../../shared/SimpleTable/SimpleTable'
import SimplePopUp from '../../shared/SimplePopUp/SimplePopUp'
import SimpleDeletePopUp from '../../shared/SimpleDeletePopUp/SimpleDeletePopUp'
import GroupForm from './GroupForm'
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline'
import AlertMessage from '../../shared/Notify/AlertMessage'
import ProgressBar from '../../shared/ProgressBar/ProgressBar'
import ErrorPage from '../../shared/ErrorPage/ErrorPage'

class Groups extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      model: 'Group',
      groups: [],
      openPopup: false,
      openDeletePopup: false,
      group: {},
      initialGroup: { uid: '', name: '' },
      title: '',
      load: false,
      tableHead: ['Name'],
      withShow: false,
      withEdit: true,
      maxWidth: 'sm',
      error_messages: '',
      notify: {},
      isOpen: false,
      message: '',
      type: '',
      loadGroupsError: null
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleDeleteItem = this.handleDeleteItem.bind(this)
    this.handleCreateorUpdateItem = this.handleCreateorUpdateItem.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleOpenDeletePopup = this.handleOpenDeletePopup.bind(this)
    this.handleDeleteClose = this.handleDeleteClose.bind(this)
    this.handleCloseAlert = this.handleCloseAlert.bind(this)
  }

  componentDidMount() {
    this.loadGroups(process.env.REACT_APP_API_DOMAIN + '/v1/groups')
  }

  loadGroups(url) {
    axios({
      method: 'get',
      url: url,
      headers: { 'X-APP-API-KEY': localStorage.getItem('api_key') }
    })
      .then((resp) => {
        this.setState({ groups: resp.data.data })
        this.setState({ load: true })
      })
      .catch((error) =>
        this.setState({ loadGroupsError: error.response.status })
      )
  }

  handleSubmit() {
    const item = this.state.group
    var method = ''
    var url = ''
    if (item.uid === '') {
      method = 'post'
      url = process.env.REACT_APP_API_DOMAIN + '/v1/groups/'
    } else {
      method = 'put'
      url = process.env.REACT_APP_API_DOMAIN + '/v1/groups/' + item.uid
    }
    axios({
      method: method,
      url: url,
      data: item,
      headers: { 'X-APP-API-KEY': localStorage.getItem('api_key') }
    })
      .then((resp) => {
        const newData = resp.data
        this.setState({
          groups: this.state.groups.filter((group) => group.uid !== item.uid)
        })
        this.setState({ groups: [...this.state.groups, newData] })
        this.setState({ openPopup: false })
        this.setState({
          isOpen: true,
          message: 'Submitted Successfully',
          type: 'success'
        })
      })
      .catch((error) => {
        if (error.response.status === 422) {
          this.setState({
            error_messages: 'Name ' + error.response.data.errors.name[0]
          })
        } else {
          this.setState({
            isOpen: true,
            message:
              error.response.status.toString() +
              ' Unexpected Error Problem Occurred',
            type: 'error'
          })
          this.setState({ openPopup: false })
        }
      })
  }

  handleDeleteItem() {
    const DeleteItemId = this.state.group.uid
    axios({
      method: 'delete',
      url: process.env.REACT_APP_API_DOMAIN + '/v1/groups/' + DeleteItemId,
      headers: { 'X-APP-API-KEY': localStorage.getItem('api_key') }
    })
      .then(() => {
        this.setState({
          groups: this.state.groups.filter((item) => item.uid !== DeleteItemId)
        })
        this.setState({ openDeletePopup: false })
        this.setState({
          isOpen: true,
          message: 'Deleted Successfully',
          type: 'error'
        })
      })
      .catch((error) => console.log(error.response))
  }

  handleClose() {
    this.setState({ openPopup: false })
    this.setState({ openDeletePopup: false })
    this.setState({ error_messages: '' })
  }

  handleCreateorUpdateItem(item, isAdd, model) {
    var textTitle = ''
    if (isAdd) {
      textTitle = 'Create ' + model
    } else {
      textTitle = 'Edit ' + model
    }
    this.setState({ openPopup: true })
    this.setState({ group: item })
    this.setState({ title: textTitle })
  }

  handleInputChange(e) {
    this.setState({
      group: {
        ...this.state.group,
        [e.target.name]: e.target.value
      }
    })
  }

  handleOpenDeletePopup(item, model) {
    this.setState({ model: model })
    this.setState({ group: item })
    this.setState({ openDeletePopup: true })
  }

  handleDeleteClose() {
    this.setState({ openDeletePopup: false })
  }

  handleCloseAlert(event, reason) {
    if (reason === 'clickaway') {
      return
    }
    this.setState({ isOpen: false })
  }

  render() {
    const { load, loadGroupsError } = this.state

    return (
      <>
        {load && !loadGroupsError ? (
          <div>
            <SimpleTable
              handleClick={this.handleCreateorUpdateItem}
              initialItem={this.state.initialGroup}
              items={this.state.groups.sort((a, b) =>
                a.name > b.name ? 1 : -1
              )}
              model={this.state.model}
              onOpenDeletePopup={this.handleOpenDeletePopup}
              headers={this.state.tableHead}
              withShow={this.state.withShow}
              withEdit={this.state.withEdit}
              icon={<PeopleOutlineIcon fontSize="large" />}
            />
            <SimplePopUp
              openPopup={this.state.openPopup}
              title={this.state.title}
              items={this.state.groups}
              handleClose={this.handleClose}
              maxWidth={this.state.mdWidth}
            >
              <GroupForm
                error={this.state.error_messages}
                item={this.state.group}
                submit={this.handleSubmit}
                onchange={this.handleInputChange}
              />
            </SimplePopUp>

            <SimpleDeletePopUp
              openDeletePopup={this.state.openDeletePopup}
              item={this.state.group}
              delete={this.handleDeleteItem}
              handleDeleteClose={this.handleClose}
              model={this.state.model}
            />
            <AlertMessage
              notify={this.state.notify}
              handleCloseAlert={this.handleCloseAlert}
              isOpen={this.state.isOpen}
              type={this.state.type}
              message={this.state.message}
            />
          </div>
        ) : loadGroupsError ? (
          <ErrorPage type={loadGroupsError} />
        ) : (
          <ProgressBar model={this.state.model} />
        )}
      </>
    )
  }
}

export default Groups
